import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MaterialPriceDto } from '../../dtos';
import { ApiError, LoadingIndicator, useFailedUpdateSnackbar, useSuccessfulUpdateSnackbar } from '../../Components/CoreLib/library';
import { useGetMaterialPriceByIdQuery, useUpdateMaterialPriceMutation } from '../../store/generated/generatedApi';
import { MaterialPriceForm } from '../../Components/Forms/MaterialPriceForm';

export const EditMaterialPriceView: FC = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { data, isLoading, error, refetch } = useGetMaterialPriceByIdQuery({ id: id! });
    const [updateMaterialPrice, { isLoading: loadingUpdate, isSuccess, isError, error: updateError, reset }] = useUpdateMaterialPriceMutation();

    useSuccessfulUpdateSnackbar('Material Price', isSuccess, reset);
    useFailedUpdateSnackbar('Material Price', isError, reset, updateError);

    const handleSave = (values: MaterialPriceDto) => {
        if (!loadingUpdate) {
            updateMaterialPrice(values);
        }
    };

    const handleCancel = () => {
        navigate('/dataManagement/materialPrices');
    };

    if (isLoading) {
        return <LoadingIndicator />;
    }

    if (error) {
        return <ApiError onReloadClick={refetch} />;
    }

    return <MaterialPriceForm save={handleSave} cancel={handleCancel} initValues={data} />;
};
